import styled from "@emotion/styled";
import { fonts } from "styles/fonts";

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  font-family: ${fonts.rubikRegular};
  position: relative;
  padding: 32px 50px;

  @media (max-width: 768px) {
    padding: 16px 16px;
  }
`;

export const Title = styled.h3`
  font-family: ${fonts.rubikRegular};
  font-style: normal;
  font-weight: 500;
  font-size: 30px;
  line-height: 34px;
  letter-spacing: -1px;
  color: #000000;
`;

export const Text = styled.p`
  font-family: ${fonts.rubikRegular};
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #000000;
`;

export const CloseIcon = styled.img`
  position: absolute;
  top: -16px;
  right: -16px;
  cursor: pointer;
`;

export const Shadow = styled.div`
  content: "";
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  top: 0px;
  left: 0px;
  background: linear-gradient(rgba(34, 36, 36, 0) 54.17%, rgba(34, 36, 36, 0.5) 100%);
`;
export const ImagesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 35px;

  @media (max-width: 768px) {
    flex-direction: column;
    margin-top: 16px;
    gap: 16px;
  }
`;

export const AppStoreImage = styled.img`
  max-width: 140px;
  max-height: 40px;
  cursor: pointer;
`;

export const QRcontainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  padding: 16px;
  width: 100%;

  min-width: 240px;

  img {
    max-width: 110px;
    max-height: 110px;
    margin-right: 16px;
  }

  p {
    font-family: ${fonts.rubikRegular};
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #686868;
  }
`;
